import { useCallback } from 'react';
import { pushToDataLayer } from 'Utils/domainConfig';
import MenbAdVrtInfoApi from 'Apis/MenbAdVrtInfoApi';

type AdPayloadSource = {
  idntCd?: unknown;
  adInfo?: Record<string, unknown> | null;
  advrtInfo?: Record<string, unknown> | null;
} | null | undefined;

export const buildAdPayload = (source: AdPayloadSource): Record<string, unknown> => {
  const adPayloadRaw = source
    ? {
      idntCd: source.idntCd,
      ...(source.adInfo || source.advrtInfo || {}),
    }
    : {};

  return Object.entries(adPayloadRaw).reduce<Record<string, unknown>>((acc, [key, value]) => {
    if (value != null) {
      acc[key] = value;
    }
    return acc;
  }, {});
};

export const getKstTimestamp = (): string => {
  return new Date(Date.now() + 9 * 60 * 60 * 1000)
    .toISOString()
    .replace('T', ' ')
    .replace(/\.\d{3}Z$/, '+09:00');
    // KST 타임스탬프를 ISO 형식으로 반환 (예: "2024-06-01 12:00:00+09:00")
};

export const fetchAdPayload = async (gameSvcCd?: string | null): Promise<Record<string, unknown>> => {
  try {
    const resp = await MenbAdVrtInfoApi(String(gameSvcCd || 'BBO'));
    if (resp?.apiHdr?.code === 'MEMB0000') {
      return buildAdPayload(resp.apiBody);
    }
  } catch {
    // Ignore API errors and fallback to empty payload.
  }

  return {};
};

/**
 * useGtm
 * - 안전하게 GTM/dataLayer로 이벤트를 푸시하는 훅
 * - 페이지나 컴포넌트에서 import 후 `push` 호출
 */
export const useGtm = () => {
  const push = useCallback((eventName: string, params?: Record<string, any>) => {
    if (typeof window === 'undefined') return;
    // dataLayer가 아직 없다면 초기화 (GTM 스니펫이 늦게 로드될 때 대비)
    window.dataLayer = window.dataLayer || [];
    pushToDataLayer(eventName, params);
  }, []);

  return { push } as const;
};

export default useGtm;
